import script from "./CustomFieldLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldLabel.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldLabel.vue?vue&type=style&index=0&id=7e6671f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e6671f0"]])

export default __exports__